import React from 'react';

/**
 * Κεφαλίδα της Αρχικής και των αναφορών: μικρό κεφαλαίο (ή «← Αρχική › Αναλυτικά»), τίτλος, μία γραμμή —
 * και δεξιά ο επιλογέας περιόδου με την «Εξαγωγή». Ίδιες κλάσεις τυπογραφίας με την κεφαλίδα του φύλλου
 * (xs-eyebrow/xs-title/xs-subtitle)· η κεφαλίδα του SettingsSheet κρύβεται στο home.css, γιατί δεν έχει
 * θέση για χειριστήρια.
 */
export const HomeHeader: React.FC<{
  crumb?: React.ReactNode;
  title: string;
  subtitle?: React.ReactNode;
  tools?: React.ReactNode;
  /** Δεύτερη γραμμή κάτω από τον υπότιτλο (π.χ. «η ανανέωση απέτυχε»). */
  status?: React.ReactNode;
}> = ({ crumb, title, subtitle, tools, status }) => (
  <header className="xh-head">
    <div className="xh-head-text">
      {crumb && <div className="xs-eyebrow xh-crumb">{crumb}</div>}
      <h1 className="xs-title">{title}</h1>
      {subtitle && <p className="xs-subtitle" data-testid="home-subtitle">{subtitle}</p>}
      {status}
    </div>
    {tools && <div className="xh-tools">{tools}</div>}
  </header>
);

export default HomeHeader;
